var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.86607 11.9641C7.86607 14.1965 9.67739 16.0669 11.9717 16.0669C14.2661 16.0669 16.1378 14.2569 16.1378 11.9641C16.1378 9.67139 14.2057 7.86133 11.9717 7.86133C9.73777 7.86133 7.86607 9.67139 7.86607 11.9641ZM14.6286 11.9632C14.6286 13.4294 13.4392 14.618 11.972 14.618C10.5048 14.618 9.31539 13.4294 9.31539 11.9632C9.31539 10.497 10.5048 9.30846 11.972 9.30846C13.4392 9.30846 14.6286 10.497 14.6286 11.9632Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2579 8.64534C15.7145 8.64534 15.2919 8.22299 15.2919 7.67997C15.2919 7.13695 15.7145 6.7146 16.2579 6.7146C16.8013 6.7146 17.2239 7.13695 17.2239 7.67997C17.2239 8.22299 16.8013 8.64534 16.2579 8.64534Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6717 18.7822C19.517 17.9375 20 16.7308 20 15.3431V8.70616C20 7.31845 19.5774 6.17208 18.7321 5.32738C17.8868 4.48268 16.7396 4 15.3509 4H8.70943C5.8717 4 4 5.93073 4 8.70616V15.3431C4 16.7308 4.42264 17.9375 5.3283 18.7822C6.17358 19.6269 7.38113 20.0492 8.70943 20.0492H15.2906C16.6189 20.0492 17.8264 19.6269 18.6717 18.7822ZM8.64922 5.44775H15.2907C16.3171 5.44775 17.102 5.74943 17.7058 6.35279C18.2492 6.95614 18.5511 7.7405 18.5511 8.70587V15.3428C18.5511 16.3081 18.2492 17.1528 17.6454 17.6958C17.102 18.2389 16.2568 18.5405 15.2907 18.5405H8.7096C7.74356 18.5405 6.95865 18.2389 6.35488 17.6958C5.75111 17.0925 5.44922 16.2478 5.44922 15.2824V8.64553C5.44922 7.68016 5.75111 6.83547 6.2945 6.29245C6.8379 5.74943 7.68318 5.44775 8.64922 5.44775Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.43435ee0cc866b71230dd483fdd73bf3.svg";
export { ForwardRef as ReactComponent };